import type { Notification } from "../../common/types/notificationTypes";

export const filterOldNotifications = (notifications: Notification[], activeNotifications: Notification[]) =>
   notifications.filter(
      (notification) => !activeNotifications.some((activeNotification) => notification.id === activeNotification.id)
   );
